import React from 'react';
import { Table } from 'antd';

import Img from '../../../../components/Img/Img';
import expandedArrow from '../../../../static/images/common/arrow_top_outline_black_w24_btn.png';
import noneExpandedArrow from '../../../../static/images/common/arrow_bottom_outline_black_w24_btn.png';
import { CATEGORY_STATUS_TYPE } from '../../../../constants/service/app/categoryConstants';
import { columns } from './columns';
import './TotalCategoryTable.scss';

const TotalCategoryTable = (props) => {
  const { totalCategoryDataSource, rowSelection } = props;

  return (
    <div className="total-category-table-wrap">
      <Table
        rowKey={(record) => record.id}
        rowSelection={rowSelection}
        columns={columns()}
        dataSource={totalCategoryDataSource}
        pagination={false}
        scroll={{ y: 'calc(100vh - 420px)' }}
        rowClassName={(record) => {
          let className = '';

          // 2차 카테고리를 포함하는 1차 카테고리일 때
          if (record?.children?.length) className += 'contain-sub-category';

          // 상태가 비활성인 카테고리일 때
          if (record.status === CATEGORY_STATUS_TYPE.INACTIVE) className += ' contain-inactive-category';

          return className;
        }}
        expandRowByClick
        expandIcon={({ expanded }) =>
          expanded ? (
            <Img className="row-expand-icon" clickAble={false} src={expandedArrow} />
          ) : (
            <Img className="row-expand-icon" clickAble={false} src={noneExpandedArrow} />
          )
        }
      />
    </div>
  );
};

export default TotalCategoryTable;
